import {
  PRESCRIPTION_FAILED,
  PRESCRIPTION_LOADED,
  PRESCRIPTION_LOADING,
  PRESCRIPTION_SAVED,
  PRESCRIPTION_SUCCESS,
  PRESCRIPTION_LOADING_DATA,
  SYNC_CERCLUCENT_CASES_TO_UL_SUCCESS,
  SYNC_CERCLUCENT_CASES_TO_UL_FAILED,
  CERLUCENT_CASE_SYNCING,
  MESSAGES_MARKED_AS_READ,
  GET_RX_DETAILS_FOR_LABSLIP_LOADING,
  GET_RX_DETAILS_FOR_LABSLIP_SUCCESS,
  GET_RX_DETAILS_FOR_LABSLIP_FAILED,
} from '../actions/types';
import has from 'lodash/has';

const initialState = {
  loading: false,
  loadingData: false,
  success: false,
  error: false,
  errorMessage: '',
  syncCaseToUL: null,
  syncCaseToULMessage: null,
  syncingCase: null,
  getRxDetailsForLabslipLoading: false,
  getRxDetailsForLabslipError: null,
  getRxDetailsForLabslipData: null,
  data: {
    contents: [],
    totalPages: 0,
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
const prescriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRESCRIPTION_LOADING_DATA:
      return {
        ...initialState,
        loadingData: true,
        loading: false,
        success: false,
        loaded: false,
        error: false,
        errorMessage: '',
        data: [],
      };
    case SYNC_CERCLUCENT_CASES_TO_UL_SUCCESS:
      return {
        ...state,
        syncCaseToUL: true,
        syncCaseToULMessage: action.payload,
        syncingCase: null,
      };
    case SYNC_CERCLUCENT_CASES_TO_UL_FAILED:
      return {
        ...state,
        syncCaseToUL: false,
        syncCaseToULMessage: action.payload,
        syncingCase: null,
      };
    case CERLUCENT_CASE_SYNCING:
      return {
        ...state,
        syncingCase: action.payload,
        syncCaseToULMessage: null,
        syncCaseToUL: null,
      };
    case PRESCRIPTION_LOADING:
      return {
        ...state,
        loadingData: false,
        loading: true,
        success: false,
        loaded: false,
        error: false,
        errorMessage: '',
        data: [],
      };
    case PRESCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingData: false,
        success: true,
        saved: false,
        error: false,
        errorMessage: '',
        data: action.payload,
      };
    case PRESCRIPTION_SAVED:
      return {
        ...state,
        loading: false,
        success: false,
        loadingData: false,
        saved: true,
        error: false,
        errorMessage: '',
        saved_data: action.payload,
      };
    case PRESCRIPTION_LOADED:
      const dataPayload = { ...action.payload };

      if (has(dataPayload, 'content')) {
        dataPayload.contents = dataPayload.content;
      }

      return {
        ...state,
        loadingData: false,
        success: false,
        error: false,
        errorMessage: '',
        data: dataPayload,
      };
    case PRESCRIPTION_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false,
        loadingData: false,
        success: false,
        error: true,
        errorMessage: action.payload,
      };
    case MESSAGES_MARKED_AS_READ:
      return {
        ...state,
        data: {
          ...state.data,
          contents: state.data.contents.map((item) =>
            item.case_id === action.payload
              ? { ...item, unreadMessagesCount: 0 }
              : item
          ),
        },
      };
    case GET_RX_DETAILS_FOR_LABSLIP_LOADING:
      return {
        ...state,
        getRxDetailsForLabslipLoading: true,
        getRxDetailsForLabslipError: null,
        getRxDetailsForLabslipData: null,
      };
    case GET_RX_DETAILS_FOR_LABSLIP_SUCCESS:
      return {
        ...state,
        getRxDetailsForLabslipLoading: false,
        getRxDetailsForLabslipError: null,
        getRxDetailsForLabslipData: action.payload,
      };
    case GET_RX_DETAILS_FOR_LABSLIP_FAILED:
      return {
        ...state,
        getRxDetailsForLabslipLoading: false,
        getRxDetailsForLabslipError: action.payload,
        getRxDetailsForLabslipData: null,
      };
    default:
      return state;
  }
};

export default prescriptionReducer;
